import api from './base'

export default {
  getAll ({ businessUnitId }) {
    return api().get(`company/business_units/${businessUnitId}/tables`)
  },
  getById ({ businessUnitId, id }) {
    return api().get(`company/business_units/${businessUnitId}/tables/${id}`)
  },
  save ({ businessUnitId, item }) {
    return api().put(`company/business_units/${businessUnitId}/tables`, item)
  },
  delete ({ businessUnitId, id }) {
    return api().delete(`company/business_units/${businessUnitId}/tables/${id}`)
  },
  setSortOrder ({ businessUnitId, tableId, sortOrder }) {
    return api().put(`company/business_units/${businessUnitId}/tables/${tableId}/sort_order`, { sort_order: sortOrder })
  }
}
